export default __webpack_public_path__ + "static/053-594fe4aa52a80e37ab4c18828595e70a.jpg";